module.exports = __webpack_public_path__ + "img/utilities.062e7d9f.jpeg";